<template>
  <section class="main-visual" data-style="show">
    <loading v-if="!isLoaded" />
    <div v-else ref="visualSwiper" class="swiper">
      <div class="swiper-wrapper">
        <div
          v-for="(item, key) in visualList"
          :key="key"
          class="swiper-slide visual"
        >
          <a
            :href="item.pcLinkUrl"
            class="pc"
            :data-lottie-path="item.pcLottiePath"
            :data-image-path="item.pcImagePath"
            :target="setTarget(item.pcLinkUrl)"
            :style="`background-image: url('${item.pcReplacePath}');`"
          >
            <img
              :src="item.pcReplacePath"
              class="preload-image"
              alt=""
            >
            <lottie-animation
              ref="lottie"
              class="lottie"
              :path="item.pcLottiePath"
              device="pc"
              :banner-data="item"
              :loop="false"
            />
            <video
              v-if="getContentType(item) === 'video'"
              ref="video"
              loop
              muted
              playsinline
              preload="none"
              :poster="item.pcReplacePath"
              class="visual-video"
            >
              <source
                :src="item.pcImagePath"
                type="video/mp4"
                media="(min-width: 750px)"
              >
              Sorry, your browser doesn't support embedded videos.
            </video>
          </a>
          <a
            :href="item.mobileLinkUrl"
            class="mobile"
            :data-lottie-path="item.mobileLottiePath"
            :data-image-path="item.mobileImagePath"
            :target="setTarget(item.mobileLinkUrl)"
            :style="`background-image: url('${item.mobileReplacePath}');`"
          >
            <img
              :src="item.mobileReplacePath"
              class="preload-image"
              alt=""
            >
            <lottie-animation
              class="lottie"
              :path="item.mobileLottiePath"
              :banner-data="item"
              :loop="false"
              device="mobile"
            />
            <video
              v-if="getContentType(item) === 'video'"
              ref="video"
              loop
              muted
              playsinline
              preload="none"
              :poster="item.mobileReplacePath"
              class="visual-video"
            >
              <source
                :src="item.mobileImagePath"
                type="video/mp4"
                media="(max-width: 750px)"
              >
              Sorry, your browser doesn't support embedded videos.
            </video>
          </a>
        </div>
        <div v-if="visualList.length <= 0" class="empty">
          <div class="visual-image">
            <img src="@/static/image/temp/main/visual_1_1920x900.jpeg" alt="">
          </div>
          <div class="visual-inner">
            <p class="visual-title">우아한형제들이 알고 싶다</p>
            <p class="visual-catchphrase">나도 누군가에게<br> 회사다!</p>
            <span class="visual-link">회사소개<icon-chevron-right-bold /></span>
          </div>
        </div>
      </div>
      <div ref="pagination" class="swiper-pagination" />
    </div>
  </section>
</template>

<script>
import mainApi from '@/api/main'
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper'
import lottie from 'lottie-web'
import axios from 'axios'

Swiper.use([Navigation, Pagination, Autoplay])

export default {
  components: {
    LottieAnimation: () => import('@/components/base/LottieAnimation'),
    loading: () => import('@/components/base/Loading'),
    iconChevronRightBold: () => import('@/static/svg/chevron-right-bold.svg')
  },
  data () {
    return {
      visualSlider: null,
      visualList: [],
      media: this.$media,
      currentPlayer: null,
      player: [],
      animationData: {},
      currentIndex: 0,
      isLoaded: false,
      isLottieLoaded: false,
      deviceType: 'pc'
    }
  },
  watch: {
    '$route.params.locale' () {
      if (this.visualSlider) {
        this.visualSlider.destroy()
      }
      this.getList()
    }
  },
  mounted () {
    this.deviceType = this.$media === 'sm' ? 'mobile' : 'pc'
    this.getList()

    window.addEventListener('resize', () => {
      this.media = this.$media
      this.deviceType = this.$media === 'sm' ? 'mobile' : 'pc'
      // appHeight()
    })
  },
  methods: {
    async getList () {
      this.isLoaded = false
      const { data } = await mainApi.getBannerList()

      this.visualList = data
      this.isLoaded = true

      if (this.visualList.length > 1) {
        setTimeout(this.setVisualSwiper, 100)
      }
    },
    async loadJsonData (lottiePath, imagePath) {
      if (!lottiePath) {
        return false
      }
      const data = await axios.get(lottiePath).then(response => {
        return response.data
      })

      if (imagePath) {
        data.assets.forEach(item => {
          item.u = imagePath
          item.p = ''
        })
      }

      return data
    },
    setVisualSwiper () {
      const that = this

      const options = {
        autoplay: {
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          delay: 5000
        },
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        // loopFillGroupWithBlank: true,
        pagination: {
          el: this.$refs.pagination,
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return `<button type="button" class="${className}">${index + 1}</button>`
          },
          bulletActiveClass: 'active',
          bulletClass: 'swiper-pagination-bullet',
          bulletElement: 'button',
          modifierClass: ''
        },
        on: {
          afterInit (s) {
            // const index = s.activeIndex
            // const preLoadImage = s.slides[index].querySelector(`a.${that.deviceType} .preload-image`)

            if (that.visualList[0].pcReplacePath.length > 0) {
              // preLoadImage.addEventListener('load', (e) => {
              //   that.setLottie(s)
              // })
              setTimeout(() => {
                that.setLottie(s)
              }, 100)
            } else {
              that.setLottie(s)
            }
          },
          resize (s) {
            that.setLottie(s, 'change')
          },
          realIndexChange (s) {
            that.setLottie(s, 'change')
          }
        }
      }

      this.visualSlider = new Swiper(this.$refs.visualSwiper, options)
    },
    getContentType (item) {
      const content = this.media === 'sm' ? item.mobileImagePath : item.pcImagePath
      let contentType = ''

      if (/\.mp4$/i.exec(content)) {
        contentType = 'video'
      } else {
        contentType = 'image'
      }

      return contentType
    },
    setTarget (link) {
      if (/(?:[\w.]*?)(?:[beta]?)woowahan.com/.test(link)) {
        return '_self'
      } else {
        return '_blank'
      }
    },
    setLottie (s, type) {
      const index = s.activeIndex
      const wrapper = s.slides[index].querySelector(`.${this.deviceType}`)
      const lottieEl = wrapper.querySelector('.lottie')
      const videoEl = wrapper.querySelector('video')

      if (lottieEl) {
        wrapper.parentElement.classList.add('loaded')

        const getLottie = lottie.getRegisteredAnimations().find(item => {
          return item.wrapper === lottieEl
        })

        if (!getLottie) {
          // lottie를 검색 할수 없으면 재귀호출
          setTimeout(() => {
            this.setLottie(s)
          }, 10)
        }

        if (getLottie && getLottie.isLoaded) {
          getLottie.wrapper.classList.add('loaded')
          getLottie.goToAndPlay(0, true)
        } else {
          if (type === 'change') {
            const cloneContainer = s.slides[index].querySelectorAll('a')

            cloneContainer.forEach(item => {
              const lottieItem = item.querySelector('.lottie')
              lottieItem.innerHTML = ''
              this.loadJsonData(item.dataset.lottiePath, item.dataset.imagePath).then(jsonData => {
                const cloneLottie = lottie.loadAnimation({
                  container: lottieItem,
                  renderer: 'svg',
                  loop: false,
                  autoplay: true,
                  animationData: jsonData,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                    scaleMode: 'centerCrop',
                    clearCanvas: true,
                    progressiveLoad: false,
                    hideOnTransparent: true
                    // className: 'lottie'
                  }
                })
                cloneLottie.wrapper.classList.add('loaded')
              })
            })
          }
        }

        if (videoEl) {
          videoEl.play()
        }
      }
    },
    isLottie (item, type) {
      return type === 'mobile' ? !!item.mobileLottiePath : !!item.pcLottiePath
    },
    // onImageLoaded (e, item, type) {
    //   e.target.src = item[`${type}ImagePath`]
    //   e.target.classList.add('loaded')
    // },
    onLoadedImage (e) {
      e.target.parentElement.classList.add('loaded')
    }
  }
}
</script>

<style>
.lottie {
  height: 100%;
}
</style>
